/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from "owa-viewstate-store";
import { createStore } from "owa-satcheljs";
import type { Building, Features, Campus, Place, ReportWindow, ReportType } from "owa-graph-schema";
import type { ReportData } from "hybridspace-graphql/lib/utils/reportDataType";

const getStore = createStore<PlacesAnalyticsAppStore>("places-analytics-app-store", {
    listUserFeatureAccess: undefined as Array<Features | null> | undefined,
    latestReportDatesData: undefined as Array<{
        key?: string | null;
        value?: string | null;
    } | null> | undefined,
    buildingsListString: undefined as string | undefined,
    buildings: undefined as Building[] | undefined,
    campusesMap: new Map<string, Campus[]>(), // Map of cityId to campuses
    floorsMap: new Map<string, Place[]>(), // Map of buildingId to floors
    sectionsMap: new Map<string, Place[]>(), // Map of floorId to sections
    // for rooms & deskpool count map, key is the combination of buildingId & floorId `${buildingId}_${floorId || 'ALL_FLOORS'}`
    roomsCountMap: new Map<string, number>(),
    deskPoolsCountMap: new Map<string, number>(),
    reportMap: new Map<string, ReportData>(),
});

export interface PlacesAnalyticsAppStore {
    listUserFeatureAccess?: Array<Features | null>;
    latestReportDatesData?: Array<{
        key?: string | null;
        value?: string | null;
    } | null>;
    buildingsListString?: string;
    buildings?: Building[];
    campusesMap: Map<string, Campus[]>; // Map of cityId to campuses
    floorsMap: Map<string, Place[]>; // Map of buildingId to floors
    sectionsMap: Map<string, Place[]>; // Map of floorId to sections
    // for rooms & deskpool count map, key is the combination of buildingId & floorId `${buildingId}_${floorId || 'ALL_FLOORS'}`
    roomsCountMap: Map<string, number>;
    deskPoolsCountMap: Map<string, number>;
    reportMap: Map<string, {
        __typename?: "V2Report";
        reportType?: ReportType | null;
        reportWindow?: ReportWindow | null;
        metric?: {
            __typename?: "V2ReportMetric";
            headers?: Array<string | null> | null;
            data?: Array<{
                __typename?: "ReportMetricValue";
                values?: // for rooms & deskpool count map, key is the combination of buildingId & floorId `${buildingId}_${floorId || 'ALL_FLOORS'}` // Map of buildingId to floors
                Array<string | null> | null;
            } | null> | null;
        } | null;
    }>;
}

export const store: PlacesAnalyticsAppStore = 
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getStore called at module scope is not allowed. This may cause unwanted side effects. */
getStore();

const dest = createAccessors("places-analytics-app-store", getStore);
export const getListUserFeatureAccess: () => (Features | null)[] | undefined = dest.getListUserFeatureAccess ?? (() => undefined);
export const setListUserFeatureAccess: (newValue: (Features | null)[] | undefined) => void = dest.setListUserFeatureAccess ?? (() => undefined);
export const getLatestReportDatesData: () => ({
    key?: string | null;
    value?: string | null;
} | null)[] | undefined = dest.getLatestReportDatesData ?? (() => undefined);
export const setLatestReportDatesData: (newValue: ({
    key?: string | null;
    value?: string | null;
} | null)[] | undefined) => void = dest.setLatestReportDatesData ?? (() => { });
export const setBuildingsListString: (newValue: string | undefined) => void = dest.setBuildingsListString ?? (() => { });
export const getBuildings: () => Building[] | undefined = dest.getBuildings ?? (() => undefined);
export const setBuildings: (newValue: Building[] | undefined) => void = dest.setBuildings ?? (() => { });
export const getCampusesMap: () => Map<string, Campus[]> = dest.getCampusesMap;
export const setCampusesMap: (newValue: Map<string, Campus[]>) => void = dest.setCampusesMap;
export const getFloorsMap: () => Map<string, Place[]> = dest.getFloorsMap;
export const setFloorsMap: (newValue: Map<string, Place[]>) => void = dest.setFloorsMap;
export const getSectionsMap: () => Map<string, Place[]> = dest.getSectionsMap;
export const setSectionsMap: (newValue: Map<string, Place[]>) => void = dest.setSectionsMap;
export const getRoomsCountMap: () => Map<string, number> = dest.getRoomsCountMap;
export const setRoomsCountMap: (newValue: Map<string, number>) => void = dest.setRoomsCountMap;
export const getDeskPoolsCountMap: () => Map<string, number> = dest.getDeskPoolsCountMap;
export const setDeskPoolsCountMap: (newValue: Map<string, number>) => void = dest.setDeskPoolsCountMap;
export const getReportMap: () => Map<string, {
    __typename?: "V2Report";
    reportType?: ReportType | null;
    reportWindow?: ReportWindow | null;
    metric?: {
        __typename?: "V2ReportMetric";
        headers?: Array<string | null> | null;
        data?: Array<{
            __typename?: "ReportMetricValue";
            values?: // for rooms & deskpool count map, key is the combination of buildingId & floorId `${buildingId}_${floorId || 'ALL_FLOORS'}` // Map of buildingId to floors
            Array<string | null> | null;
        } | null> | null;
    } | null;
}> = dest.getReportMap;
export const setReportMap: (newValue: Map<string, {
    __typename?: "V2Report";
    reportType?: ReportType | null;
    reportWindow?: ReportWindow | null;
    metric?: {
        __typename?: "V2ReportMetric";
        headers?: Array<string | null> | null;
        data?: Array<{
            __typename?: "ReportMetricValue";
            values?: // for rooms & deskpool count map, key is the combination of buildingId & floorId `${buildingId}_${floorId || 'ALL_FLOORS'}` // Map of buildingId to floors
            Array<string | null> | null;
        } | null> | null;
    } | null;
}>) => void = dest.setReportMap;
